const t = "inactive_c0lyb", e = "titleContainer_r-r1Q", n = "prelude_Q-Oac", i = "buttons_zjuO4", o = {
  inactive: t,
  titleContainer: e,
  prelude: n,
  buttons: i
};
export {
  i as buttons,
  o as default,
  t as inactive,
  n as prelude,
  e as titleContainer
};
//# sourceMappingURL=inactive.module.scss.js.map
